'use strict';

const DashboardServiceImpl = require('services/DashboardServiceImpl'),
    ContentUtils = require('utils/ContentUtils');

const IconStore = {

    fetchIcons(success, failure) {
        DashboardServiceImpl.getIcons(function () {
            const icons = ContentUtils.parse(this.responseText);
            if (success) {
                success(icons);
            }
        }, failure);
    }
};

module.exports = IconStore;



/** WEBPACK FOOTER **
 ** ./src/stores/IconStore.js
 **/